"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Router = _interopRequireDefault(require("../abstracts/Router"));

var BrowserRouter = /*#__PURE__*/function (_AbstractRouter) {
  (0, _inherits2["default"])(BrowserRouter, _AbstractRouter);

  var _super = (0, _createSuper2["default"])(BrowserRouter);

  function BrowserRouter() {
    (0, _classCallCheck2["default"])(this, BrowserRouter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BrowserRouter, [{
    key: "render",
    value: function render() {
      return function (_ref) {
        var children = _ref.children;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, children);
      };
    }
  }]);
  return BrowserRouter;
}(_Router["default"]);

var _default = BrowserRouter;
exports["default"] = _default;